import { Grid, Tooltip} from "@mui/material";

export function getOrderpomappingStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        orderid:{
            name:'orderid',
            label:'Order Id',
            value:'',
            error:false,
            errorMessage:'You must enter Order Id',
            required:true,
            fieldtype:'ID'
        },
        poid:{
            name:'poid',
            label:'PO Id',
            value:'',
            error:false,
            errorMessage:'You must enter PO Id',
            required:true,
            fieldtype:'ID'
        },
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'You must enter Business Id',
            required:true,
            fieldtype:'ID'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'orderid', headerName: 'Order Id', width:50 },
        { field: 'poid', headerName: 'PO Id', width:50 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['orderid']:{
          ...formValues['orderid'],
          value:data.orderid,
        },['poid']:{
          ...formValues['poid'],
          value:data.poid,
        },['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },
      })
}